import React from 'react'
import Table from '../../components/common/Table'
import { SurveyInviteDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'
import { renderBooleanBadge } from '../../utils/displayUtils'
import { showToast } from '../../utils/showToast'

interface SurveyInviteTableProps {
  data: SurveyInviteDTO[];
  handleEdit: (row: SurveyInviteDTO) => void;
  handleDelete: (row: SurveyInviteDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const SurveyInviteTable: React.FC<SurveyInviteTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                
                    {
                        label: "Token",
                        key: "token",
                    },
        
                    {
                        label: "Label",
                        key: "label",
                    },
        
                    {
                        label: "Is Submitted",
                        key: "isSubmitted",
                        render: (row: SurveyInviteDTO) => renderBooleanBadge(row.isSubmitted ?? false),
                    },

                    {
                        label: "Survey Link",
                        key: "surveyLink",
                        render: (row: SurveyInviteDTO) => (
                            <button
                                type="button"
                                className="text-secondary underline text-sm"
                                onClick={() => {
                                    const link = `${window.location.origin}/survey/${row.token}`;
                                    navigator.clipboard.writeText(link);
                                    showToast('Survey link copied', 'success');
                                }}
                            >
                                Copy link
                            </button>
                        ),
                    },

                    {
                        label: "Submitted Utc",
                        key: "submittedUtc",
                    },
        
                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default SurveyInviteTable;
